<template>
    <div class="item-volo-hotel-andata" v-if="flight.voli && show">
        <ul>
            <li>
                <div :class="(isDestinazione? 'flight-dest-dep-icon' : 'flight-go-icon') + ' has-icon d-flex justify-content-between'">
                    <div>
                        <p>{{isDestinazione? destinationAirport : departureAirport}}</p>
                    </div>
                    <div class="tools">
                        <button v-if="showInfoIcon" class="btn info" @click="onClickInfo"><div></div></button>
                    </div>
                </div>
                <div class="info">
                    <span>{{isDestinazione? destinationAirportSigla : departureAirportSigla}} - {{time}}</span>
                </div>
            </li>
        </ul>
        <ModalFlightDetail :value=flight ref="modalFlightDetail" :selected="true"/>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {simpleTimeFormatter, toDateFromServer} from '../../../../utils/formatter'
import {airportName, isSameDate} from '../../../../utils/helper'
import ModalFlightDetail from '../modals/ModalFlightDetail'

export default {
  name: 'ItemVoloAndata',
  components: {ModalFlightDetail},
  props: {
    isDestinazione: {
      type: Boolean,
      value: false
    },
    day: {
      type: Date,
      default: () => new Date()
    }
  },
  data () {
    return {
      showInfoIcon: true
    }
  },
  computed: {
    show () {
      if (!this.isDestinazione) return true
      return isSameDate(this.destinationDate, this.day)
    },
    isTourFlight () {
      return !this.getFlightFrom().voli && this.getTour().flights
    },
    flight () {
      return this.isTourFlight ? this.getTour().flights[0] : this.getFlightFrom()
    },
    primoVolo () {
      return this.flight.voli[0]
    },
    ultimoVolo () {
      const flight = this.getFlightFrom()
      return flight.voli[flight.voli.length - 1]
    },
    departureAirport () {
      return airportName(this.primoVolo.partenza.aeroporto.airport.objA)
    },
    destinationAirport () {
      return airportName(this.ultimoVolo.destinazione.aeroporto.airport.objA)
    },
    departureAirportSigla () {
      return this.primoVolo.partenza.aeroporto.airport.objB
    },
    destinationAirportSigla () {
      return this.ultimoVolo.destinazione.aeroporto.airport.objB
    },
    destinationDate () {
      return toDateFromServer(this.ultimoVolo.destinazione.dataOra.date.date)
    },
    time () {
      const time = this.isDestinazione ? this.ultimoVolo.destinazione.dataOra.time.time : this.primoVolo.partenza.dataOra.time.time
      return simpleTimeFormatter(time[0], time[1])
    },
    vector () {
      const flight = this.getFlightFrom()
      return flight ? flight.vector.objA : ''
    }
  },
  methods: {
    ...mapGetters(['getTour', 'getFlightFrom', 'getListaHotels']),
    onClickInfo () {
      this.$refs.modalFlightDetail.open()
    }
  },
  created () {
    this.showInfoIcon = !this.isTourFlight
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/itinerario/ItemVoloAndata.vue